import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reseller-hosting',
  templateUrl: './reseller-hosting.component.html',
  styleUrls: ['./reseller-hosting.component.scss']
})
export class ResellerHostingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
